export const idDoFornecedor = (fornecedor) => String(
  (typeof fornecedor === 'object' ? fornecedor?._id : fornecedor) || ''
);

const modeloDoEquipamento = (equipamento) => typeof equipamento === 'string'
  ? equipamento : equipamento?.modelo || '';

// On-grid/bombeamento usam contagens no kit; off-grid usa qtde no componente.
// Ausência de informação fica em branco, sem estimar modelos ou quantidades.
export const componentesDoKitParaEstoque = (kit) => ({
  moduloFotovoltaico: kit?.moduloFotovoltaico ?? modeloDoEquipamento(kit?.modulo),
  quantidadeModulo: kit?.quantidadeModulo ?? kit?.quantidademodulos ?? kit?.modulo?.qtde ?? '',
  inversor: modeloDoEquipamento(kit?.inversor),
  quantidadeInversor: kit?.quantidadeInversor ?? kit?.quantidadeinversores ?? kit?.inversor?.qtde ?? '',
});

export const montarCatalogoKitsEstoque = (fontes) => fontes.flatMap(({ categoria, kits }) => {
  if (!Array.isArray(kits)) throw new Error('Catálogo de kits inválido');
  return kits.filter((kit) => kit?._id && kit.ativo !== false && kit.nome?.trim())
    .map((kit) => ({
      _id: kit._id,
      nome: kit.nome,
      fornecedor: kit.fornecedor,
      ...componentesDoKitParaEstoque(kit),
      categoria,
      chaveCatalogo: `${categoria}:${kit._id}`,
    }));
});

export const filtrarKitsPorFornecedor = (kits, idFornecedor) => {
  const id = idDoFornecedor(idFornecedor);
  return id ? kits.filter((kit) => idDoFornecedor(kit.fornecedor) === id) : [];
};

// A opção histórica mantém o item e suas movimentações, sem associar por nome.
export const opcaoHistorica = (item) => item?._id && item.tipo === 'kit' && item.descricao
  ? { nome: item.descricao, fornecedor: item.idFornecedor, historico: true,
    chaveCatalogo: `estoque:${item._id}` }
  : null;

export const kitCorrespondeAoCadastro = (kit, item) => Boolean(kit
  && idDoFornecedor(item.idFornecedor)
  && idDoFornecedor(kit.fornecedor) === idDoFornecedor(item.idFornecedor)
  && kit.nome === item.descricao);
